import * as React from "react";
import { DeviceData } from "../models/DeviceData";



interface Props {
    x: string;
    y: string;
    fontSize: string;
    device?: DeviceData;
    ccf: number;

}

const ConfigVotingInfo = (props: Props) => {
  let pfdAverageDisplay = "";
  let strDisplay = "";
  let ccf = props.ccf != null ? `${props.ccf} %` : "N/A";
  if (props.device != null && props.device.ptProtectiveFunction != null) {
      const ptProtectiveFunction = props.device.ptProtectiveFunction;
      pfdAverageDisplay = `${ptProtectiveFunction.pfdAverageDisplay != null ? ptProtectiveFunction.pfdAverageDisplay : ""}`;
      strDisplay = `${(ptProtectiveFunction.strDisplay != null) ? ptProtectiveFunction.strDisplay : ""}`;
  }

    return (
        <div style={{ fontSize: props.fontSize, left: props.x, top: props.y, position: "absolute", pointerEvents: "all" }}>
            <span className="label_device">PFD: {pfdAverageDisplay}</span>
            <span className="label_device">STR: {strDisplay}</span>
            <span className="label_device">CCF: {ccf}</span>
        </div>
    );
}

export default ConfigVotingInfo;